import { LocaleEnum } from '@systemeio/ui'

export const getMercadoPagoHelpPageLink = (locale?: LocaleEnum) => {
  switch (locale) {
    case LocaleEnum.DUTCH: {
      return 'https://help-nl.systeme.io/article/2282-hoe-je-je-mercado-pago-account-integreert-met-systeme-io'
    }
    case LocaleEnum.DEUTSCH: {
      return 'https://help-de.systeme.io/article/2164-so-integrieren-sie-ihr-mercado-pago-konto-mit-systemeio'
    }
    case LocaleEnum.FRENCH: {
      return 'https://aide.systeme.io/article/2097-comment-integrer-mercado-pago-a-systeme-io'
    }
    case LocaleEnum.JAPANESE: {
      return 'https://help-jp.systeme.io/article/2318-how-to-integrate-your-mercado-pago-account-with-systeme-io'
    }
    case LocaleEnum.PORTUGUESE: {
      return 'https://help-pt.systeme.io/article/2094-como-integrar-sua-conta-do-mercado-pago-a-systeme-io'
    }
    case LocaleEnum.SPANISH: {
      return 'https://help-es.systeme.io/article/2090-como-integrar-tu-cuenta-de-mercado-pago-a-systeme-io'
    }
    case LocaleEnum.ITALIAN: {
      return 'https://help-it.systeme.io/article/2136-come-integrare-il-tuo-account-mercado-pago-con-systeme-io'
    }
    default: {
      return 'https://help.systeme.io/article/2096-how-to-integrate-your-mercado-pago-account-with-systeme-io'
    }
  }
}
